<template>
  <div>
    <v-card-text class="my-5 d-flex justify-space-between align-center pa-4">
      <p class="text-h6">Ответственный: {{ responsible_user }}</p>
    </v-card-text>
    <v-card class="my-5">
      <v-card-text>
        <v-card-actions class="px-0">
          <div class="views-history text-body-1 text-sm-h5 black--text">
            История просмотров
          </div>
          <v-spacer></v-spacer>
          <v-card elevation="0" class="d-flex align-center">
            <v-card-text
              class="toolbar-content text-caption text-sm-subtitle-1 text-no-wrap py-1 px-2"
            >
              4 сессии
            </v-card-text>
          </v-card>
          <v-spacer></v-spacer>
          <v-card elevation="0" class="d-flex align-center">
            <v-card-text
              class="toolbar-content text-caption text-sm-subtitle-1 text-no-wrap py-1 px-2"
            >
              {{ (patient.visits || []).length }} визитов
            </v-card-text>
          </v-card>
          <v-spacer></v-spacer>
        </v-card-actions>
        <object-grid
          :content_type="content_type"
          :value="patient.visits || []"
          :hide-toolbar="true"
          :show-actions="this.showActions"
          :field-defs="[
            { text: 'Сессия', value: 'product_name' },
            { text: 'Дата', value: 'date' },
          ]"
          @doEditItem="showSessionDialog"
        />
      </v-card-text>
    </v-card>
  </div>
</template>
<script>
import ObjectGrid from "@/components/ObjectGrid.vue";
import { mapActions, mapGetters } from "vuex";
import SessionForm from "@/components/SessionForm.vue";

export default {
  name: "PatientView",
  components: { ObjectGrid },
  data() {
    return { content_type: "products", showActions: { edit: true } };
  },
  computed: {
    ...mapGetters(["user"]),
    ...mapGetters("users", ["users"]),
    patient() {
      const item = this.user.Patient;
      return {
        ...(item || {}),
        age: item?.data?.age,
        comment: item?.data?.comment,
        problem: item?.data?.problem,
        condition: item?.data?.condition,
        review: item?.data?.review,
        visits: item?.data?.visits?.active ?? undefined,
      };
    },
    responsible_user() {
      const user = this.users.find(
        (user) => user.id === this.user.Patient.user_id
      );
      return user ? user.first_name + " " + user.last_name : "";
    },
  },
  methods: {
    ...mapActions("patients", ["request_patients", "update_patient"]),
    ...mapActions("users", ["request_users"]),
    ...mapActions("modals", ["showModalForm"]),

    loadPatient() {
      if (this.patient_id) this.request_patients(`id=${this.patient_id}`);
    },
    showSessionDialog(item) {
      this.showModalForm({
        title: item.product_name,
        component: SessionForm,
        width: this.$vuetify.breakpoint.smAndUp ? "50%" : "80%",
        item,
        saveMethod: (item) => {
          return this.update_patient({
            id: this.patient.id,
            data: {
              ...this.patient.data,
              visits: {
                ...this.patient?.data?.visits,
                active: [
                  ...(this.patient?.data?.visits?.active || []).filter(
                    (v) => v.id !== item.id
                  ),
                  {
                    ...item,
                  },
                ],
                viewed: [...(this.patient?.data?.visits?.viewed || [])],
              },
            },
          }).then(() => this.loadPatient());
        },
      }).then((payload) => {
        console.log(payload);
      });
    },
  },
  beforeMount() {
    this.request_users();
  },
};
</script>
<style scoped lang="scss"></style>
